export interface SprintNavigationItem {
  id: number;
  name: string;
}

export interface SprintNavigation {
  id: number;
  name: string;
  next: SprintNavigationItem | null;
  previous: SprintNavigationItem | null;
}

type SprintNavigationDTO = {
  id: number;
  name: string;
  next?: {
    id: number;
    name: string;
  } | null;
  previous?: {
    id: number;
    name: string;
  } | null;
};

export function SprintNavigationFromJSON(
  json: SprintNavigationDTO,
): SprintNavigation {
  return {
    id: json.id,
    name: json.name,
    next: json.next ? { id: json.next.id, name: json.next.name } : null,
    previous: json.previous
      ? { id: json.previous.id, name: json.previous.name }
      : null,
  };
}
